import {createSelector} from "@reduxjs/toolkit";
import {syncStateSelector} from "./syncSlice";
import {isEmpty} from "es-toolkit/compat";

export const selectSyncState = createSelector([syncStateSelector], state => {
  return !isEmpty(state) ? state : {};
});
